<template>
  <div>
    <el-radio-group  @change="change" v-model="x" size="mini">
      <el-radio-button v-for="x in xfields" :key="x.name" :label="x.name">{{x.title}}</el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  props:["xfield","xfields"],
  data() {
    return {
      x:this.xfield
    };
  },
  watch:{
    xfield(newval){
      this.x=newval
    }
  },


  methods:{
    change(val){this.$emit("xchange",val)}
  }


};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/presentation/chart/xfield.vue